export default "__VITE_ASSET__BDf5iC8Y__"